import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'app/services/auth.service';

@Injectable()
export class IsAuthenticatedAuthGuard implements CanActivate, CanActivateChild {
    constructor(private authService: AuthService, private router: Router) { }

    public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return await this.guard(state);
    }

    public async canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return await this.guard(state);
    }

    private async guard(state: RouterStateSnapshot) {
        if (await this.authService.isAuthenticated()) return true;

        this.router.navigate(['/user/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/authGuards/isAuthenticated.authGuard.ts